import { GeneralService } from './../services/general.service';
import { NotFoundError } from './../common/not-found-error';
import { AppError } from './../common/app-error';
import { DataService } from './../services/data.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


declare var grecaptcha: any;
declare var $: any;
@Component({
  selector: 'popup-inquiry',
  templateUrl: './popup-inquiry.component.html',
  styleUrls: ['./popup-inquiry.component.css']
})
export class PopupInquiryComponent implements OnInit {

  recaptchaError = true;

  constructor(private dataService: DataService,private router:Router, private GeneralService:GeneralService) { }

  private sendEmailApi = this.GeneralService.SEND_EMAIL_API;
  ngOnInit() {

  }

  inquiryForm = new FormGroup({
    firstName: new FormControl('', [Validators.required, Validators.pattern('[a-zA-Z ]*')]),
    lastName: new FormControl('', [Validators.required, Validators.pattern('[a-zA-Z ]*')]),
    email: new FormControl('', [Validators.required, Validators.email]),
    phone: new FormControl('', [Validators.required, Validators.pattern('[0-9]*'),Validators.minLength(6)]),
    country: new FormControl('', Validators.required),
    skype: new FormControl('', Validators.required),
    message: new FormControl('', [Validators.required, Validators.minLength(20)]),
    captcha: new FormControl('')
  });


  get firstName() {
    return this.inquiryForm.get('firstName');
  }

  get lastName() {
    return this.inquiryForm.get('lastName');
  }

  get email() {
    return this.inquiryForm.get('email');
  }

  get phone() {
    return this.inquiryForm.get('phone');
  }

  get country() {
    return this.inquiryForm.get('country');
  }

  get skype() {
    return this.inquiryForm.get('skype');
  }

  get message() {
    return this.inquiryForm.get('message');
  }

  onloadCallback = function() {
    alert("grecaptcha is ready!");
  };

  submitInquiryForm() {
    
    if (this.inquiryForm.valid) {


      //let response = grecaptcha.getResponse();
      //if (response.length === 0) {
        if($(".g-recaptcha-response").val() == ''){
        $('.recapError').show();
        return false;
      } else {
        $('.recapError').hide();
        //Call http request
        $('.contact-msg').show();
        this.inquiryForm.controls['captcha'].setValue($(".g-recaptcha-response").val());
        this.dataService.post(this.sendEmailApi, this.inquiryForm.value)
          .subscribe(response => {
            $('.contact-msg').hide();
            if (response.type == 'success') {
              //console.log(response.message);
              $('.green').html(response.message);
              $('.close').click();
              this.router.navigate(['/inquire-now']);
              $('.red').html('');
            }
            else{
              $('.red').html(response.message);
              $('.green').html('');
            }
          },(error: AppError) => {
            $('.close').click();
      
            //this.api_responce = false;
            if (error instanceof NotFoundError) {
              //redirect to the error page
              this.router.navigate(['/error']);
            }
            else {
              //redirect to the error page
              this.router.navigate(['/error']);
            }
            
          });
      }
    }
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/popup-inquiry/popup-inquiry.component.ts